<template>
  <div>
    <div v-show="accountId !== 'new'">
      <div class="p-team-user-profile">
        <div class="c-title">
          <div class="c-title__text">アカウント情報</div>
        </div>
        <ul class="p-team-user-profile-list">
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">
              アカウントID
            </div>
            <div class="p-team-user-profile__text">
              {{ accountId }}
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">
              アカウント名
            </div>
            <div class="p-team-user-profile__text">
              {{ account.name }}
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">略称</div>
            <div class="p-team-user-profile__text">
              {{ account.nameShort }}
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">
              アカウントトークン
            </div>
            <div class="p-team-user-profile__text">
              {{ account.accessToken }}
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">プラン</div>
            <div class="p-team-user-profile__text">
              {{ account.plan }}
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">
              利用可能機能
            </div>
            <div class="p-team-user-profile__text">
              <ol>
                <li
                  v-for="(value, key) in selectedFeatures"
                  :key="key"
                  style="list-style-type: square"
                >
                  {{ features[value] }}
                </li>
              </ol>
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">
              プッシュ対象
            </div>
            <div class="p-team-user-profile__text">
              <ol>
                <li
                  v-for="(value, key) in selectedServices"
                  :key="key"
                  style="list-style-type: square"
                >
                  {{ services[value].name }}
                </li>
              </ol>
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">
              アカウント状態
            </div>
            <div class="p-team-user-profile__text">
              {{ account.suspendFlag ? "停止" : "稼働中" }}
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">
              オプトイン状態
            </div>
            <div class="p-team-user-profile__text">
              {{
                account.optinSuspensionSetting ? "無効" : "有効"
              }}
            </div>
          </li>
          <li class="p-team-user-profile-list__item">
            <div class="p-team-user-profile__title">
              オプトイン上限
            </div>
            <div class="p-team-user-profile__text">
              {{ account.optinLimitSetting }}
            </div>
          </li>
        </ul>
      </div>
      <br />
    </div>
    <!-- ボタンエリア -->
    <div class="p-team-btns">
      <a class="c-btn c-btn--gray u-w320" @click="onCancel">
        <p class="c-btn__text">キャンセル</p>
      </a>
    </div>
    <!-- /ボタンエリア -->
  </div>
</template>

<script>
export default {
  props: {
    features: Object,
    services: Object,
    targetAccount: Object,
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      errors: {},
      selectedFeatures: this.targetAccount.features || [],
      selectedServices: this.targetAccount.services || [],
      accountId: this.targetAccount.account_id,
      account: {
        name: this.targetAccount.account_name || "",
        nameShort: this.targetAccount.account_name_short || "",
        accessToken: this.targetAccount.access_token || "",
        plan: this.targetAccount.plan || "",
        features: [],
        services: [],
        optinLimitSetting: this.targetAccount.optin_upper_limit || 0,
        suspendFlag: Boolean(
          parseInt(this.targetAccount.suspend_flag || "0")
        ),
        optinSuspensionSetting: Boolean(
          parseInt(this.targetAccount.optin_disabled || "0")
        ),
      },
    };
  },
  computed: {},
  methods: {
    onCancel: function () {
      history.back();
    },
  },
};
</script>
